import React from 'react';
import {useMediaQuery} from 'react-responsive';

import {DEVICES} from '../helpers';

export const withResponsive = WrappedComponent => {
  const HOC = props => {
    let device = DEVICES.DESKTOP;
    const isLaptop = useMediaQuery({minWidth: 992});
    const isTablet = useMediaQuery({minWidth: 768, maxWidth: 991});
    const isMobile = useMediaQuery({maxWidth: 767});

    if (isLaptop) device = DEVICES.LAPTOP;
    if (isTablet) device = DEVICES.TABLET;
    if (isMobile) device = DEVICES.MOBILE;

    return <WrappedComponent device={device} {...props} />;
  };

  return HOC;
};
